import { ServiceFetch } from '../service-fetch'

export default class StockSettingZoneModel extends ServiceFetch {
    getStockSettingZoneBy = (data) => this.authFetch({
        url: 'stock-setting-zone/getStockSettingZoneBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}